export default function formSubmit({ type }) {
    return {
        loading: false,
        errors: null,

        async submit(e) {
            if (this.loading) return;

            this.loading = true;
            this.errors = null;

            const form = e.target;
            const formData = new FormData(form);

            const payload = {};
            for (const [key, value] of formData.entries()) {
                payload[key] = value;
            }

            try {
                const res = await fetch(
                    Alpine.store('app').routes.forms.submit,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'X-CSRF-TOKEN': Alpine.store('app').csrf,
                        },
                        body: JSON.stringify({
                            type,
                            payload,
                        }),
                    }
                );

                const data = await res.json();
                if (!res.ok) throw data;

                form.reset();
                Alpine.store('formSuccess').show();

            } catch (e) {
                this.errors = e?.message ?? 'Ошибка отправки';
            } finally {
                this.loading = false;
            }
        },
    };
}
